// extracted by mini-css-extract-plugin
export default {"container":"Zt8QbOJjPaoINsCcGhbx","tab":"LwkwjefcOzAyR_k6lnN3","selected":"nbFqmUTQtRt32wN5Slie","icon":"QpOewCyykjYroa7FMN1M"};